import DocumentSearchForm from "./DocumentSearchForm";

export default DocumentSearchForm;
